var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 982,
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_37_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1162.78 -278.797L1399.03 -631.992L1211.28 -250.797L761.277 528.625L549.028 840.251L712.779 500.625L1162.78 -278.797Z",
    fill: "url(#paint0_linear_37_3)",
    fillOpacity: 0.16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_37_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1120 -737.805L1356.25 -1091L1168.5 -709.805L718.497 69.6176L506.249 381.243L670 41.6176L1120 -737.805Z",
    fill: "url(#paint1_linear_37_3)",
    fillOpacity: 0.12
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_37_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1696 -503.805L1932.25 -857L1744.5 -475.805L1294.5 303.618L1082.25 615.243L1246 275.618L1696 -503.805Z",
    fill: "url(#paint2_linear_37_3)",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_37_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1590 435.195L1826.25 82L1638.5 463.195L1188.5 1242.62L976.249 1554.24L1140 1214.62L1590 435.195Z",
    fill: "url(#paint3_linear_37_3)",
    fillOpacity: 0.05
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_37_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194 583.195L430.249 230L242.497 611.195L-207.503 1390.62L-419.751 1702.24L-256 1362.62L194 583.195Z",
    fill: "url(#paint4_linear_37_3)",
    fillOpacity: 0.12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_37_3",
    x: 429.028,
    y: -751.992,
    width: 1090,
    height: 1712.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_37_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_37_3",
    x: 410.249,
    y: -1187,
    width: 1042,
    height: 1664.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48,
    result: "effect1_foregroundBlur_37_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_37_3",
    x: 986.249,
    y: -953,
    width: 1042,
    height: 1664.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48,
    result: "effect1_foregroundBlur_37_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_37_3",
    x: 880.249,
    y: -14,
    width: 1042,
    height: 1664.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48,
    result: "effect1_foregroundBlur_37_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_37_3",
    x: -515.751,
    y: 134,
    width: 1042,
    height: 1664.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48,
    result: "effect1_foregroundBlur_37_3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_3",
    x1: 1399.03,
    y1: -631.992,
    x2: 549.028,
    y2: 840.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458645,
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_3",
    x1: 1356.25,
    y1: -1091,
    x2: 506.249,
    y2: 381.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.54
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_3",
    x1: 1456,
    y1: -33,
    x2: 1234,
    y2: 394.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_3",
    x1: 1826.25,
    y1: 82,
    x2: 1401,
    y2: 967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.54
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_3",
    x1: 430.249,
    y1: 230,
    x2: -419.751,
    y2: 1702.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.597363c83b98b17bca47324ac4e9530b.svg";
export { ForwardRef as ReactComponent };